import { FormattedMessage } from 'react-intl';

export const GadgetsUseDurationTitle = () => (
  <span data-testid="gadgets-use-duration-vp-title">
    <FormattedMessage id="vp.gadgetsUseDuration.title" />
  </span>
);